import type { Middleware } from "@reduxjs/toolkit";

import { authApi } from "../api/authApi";
import { logout as logoutAction } from "../slices/authSlice";

export const authMiddleware: Middleware = store => next => action => {
  // Type assertion with runtime checks
  const actionObj = action as any;

  // Check for 401 errors and logout user
  if (actionObj?.type?.endsWith?.("/rejected") && actionObj?.payload?.originalStatus === 401) {
    const state = store.getState() as any;
    const token = state.auth.token;

    // Only attempt server logout if we have a token
    if (token) {
      // Attempt to logout on server (fire and forget)
      // We don't wait for this to complete to avoid blocking the UI
      try {
        (store.dispatch as any)(authApi.endpoints.logout.initiate());
      } catch (error) {
        console.error("Failed to logout on server:", error);
        // Silent fail - we still want to clear local state even if server logout fails
        console.warn("Server logout failed, but local state cleared");
      }
    }

    // Always clear local state regardless of server response
    store.dispatch(logoutAction());
  }

  return next(action);
};
